import { _ as _typeof } from '../../typeof-D-UKOauR.js';
import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../../index-B0Q3DaKR.js';
import { _ as _createClass, a as _classCallCheck } from '../../createClass-DV1OmW3s.js';
import { _ as _defineProperty } from '../../defineProperty-DmV7cVMj.js';
import IS_BROWSER from '../../isBrowser/index.js';

var _Storage;
var generateErrorMessage = function generateErrorMessage(e) {
  return e instanceof Error ? e.message : JSON.stringify(e);
};
var isLocalStorageAvailable = function isLocalStorageAvailable() {
  if (IS_BROWSER) {
    try {
      var testKey = '__test__';
      window.localStorage.setItem(testKey, testKey);
      window.localStorage.removeItem(testKey);
      return window.localStorage;
    } catch (e) {
      return fakeStorage;
    }
  }
  return fakeStorage;
};

// new version
var fakeStorage = function () {
  var storage = new Map();
  return {
    getItem: function getItem(key) {
      return storage.get(key);
    },
    setItem: function setItem(key, value) {
      return storage.set(key, value);
    },
    removeItem: function removeItem(key) {
      return storage["delete"](key);
    },
    clear: function clear() {
      return storage = new Map();
    }
  };
}();
var Storage = /*#__PURE__*/function () {
  function Storage() {
    _classCallCheck(this, Storage);
    _defineProperty(this, "set", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, key, data) {
        var storageKey;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              storageKey = Storage.generateKey(name, key);
              return _context.abrupt("return", new Promise(function (resolve) {
                setTimeout(function () {
                  try {
                    if (Storage.storage.getItem(storageKey)) {
                      var message = Storage.existMessage.replace('__key__', storageKey);
                      // Logger.info(message, withConsole, Storage.printMessageStyle);
                      return resolve({
                        error: true,
                        message: message
                      });
                    }
                    Storage.storage.setItem(storageKey, Storage.handleData(data));
                    resolve({
                      error: false,
                      message: ''
                    });
                  } catch (e) {
                    return resolve({
                      error: true,
                      message: generateErrorMessage(e)
                    });
                  }
                }, 0);
              }));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(this, "put", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name, key, data) {
        var storageKey;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              storageKey = Storage.generateKey(name, key);
              return _context2.abrupt("return", new Promise(function (resolve) {
                setTimeout(function () {
                  try {
                    if (!Storage.storage.getItem(storageKey)) {
                      var message = Storage.notFoundMessage.replace('__key__', storageKey);
                      // Logger.info(message, withConsole, Storage.printMessageStyle);
                      return resolve({
                        error: true,
                        message: message
                      });
                    }
                    Storage.storage.setItem(storageKey, Storage.handleData(data));
                    resolve({
                      error: false,
                      message: ''
                    });
                  } catch (e) {
                    return resolve({
                      error: true,
                      message: generateErrorMessage(e)
                    });
                  }
                }, 0);
              }));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(this, "get", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(name, key) {
        var storageKey;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              storageKey = Storage.generateKey(name, key);
              return _context3.abrupt("return", new Promise(function (resolve) {
                setTimeout(function () {
                  var returnValue;
                  try {
                    returnValue = JSON.parse(Storage.storage.getItem(storageKey));
                  } catch (e) {
                    // Logger.error(e as string, withConsole);
                  }
                  if (returnValue) {
                    return resolve({
                      error: false,
                      message: '',
                      date: returnValue
                    });
                  }
                  var message = Storage.notFoundMessage.replace('__key__', storageKey);
                  // Logger.info(message, withConsole, Storage.printMessageStyle);
                  return resolve({
                    error: true,
                    message: message,
                    date: null
                  });
                }, 0);
              }));
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x7, _x8) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(this, "remove", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(name, key) {
        var storageKey;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              storageKey = Storage.generateKey(name, key);
              return _context4.abrupt("return", new Promise(function (resolve, reject) {
                setTimeout(function () {
                  try {
                    Storage.storage.removeItem(storageKey);
                    return resolve({
                      error: false,
                      message: ''
                    });
                  } catch (e) {
                    return reject({
                      error: true,
                      message: e instanceof Error ? e.message : JSON.stringify(e)
                    });
                  }
                }, 0);
              }));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x9, _x10) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(this, "clear", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", new Promise(function (resolve) {
              setTimeout(function () {
                try {
                  Storage.storage.clear();
                  return resolve({
                    error: false,
                    message: ''
                  });
                } catch (e) {
                  return resolve({
                    error: true,
                    message: e instanceof Error ? e.message : JSON.stringify(e)
                  });
                }
              }, 0);
            }));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })));
    _defineProperty(this, "setSync", function (name, key, data) {
      var onError = arguments.length > 4 ? arguments[4] : undefined;
      var storageKey = Storage.generateKey(name, key);
      if (Storage.storage.getItem(storageKey)) {
        // const message = Storage.existMessage.replace('__key__', storageKey);
        // Logger.info(message, withConsole, Storage.printMessageStyle);
        return;
      }
      try {
        Storage.storage.setItem(storageKey, Storage.handleData(data));
      } catch (e) {
        if (typeof onError === 'function') onError(e);
      }
    });
    _defineProperty(this, "putSync", function (name, key, data, isAnalytic) {
      var onError = arguments.length > 5 ? arguments[5] : undefined;
      var storageKey = Storage.generateKey(name, key);
      // if (!Storage.storage.getItem(storageKey)) {
      //   // const message = Storage.notFoundMessage.replace('__key__', storageKey);
      //   // Logger.info(message, withConsole, Storage.printMessageStyle);
      // }
      // @ts-ignore
      var realData = isAnalytic ? data === null || data === undefined ? undefined : data.filter(function (item, i, self) {
        return self.findIndex(function (v2) {
          var _v2$event, _item$event;
          return (v2 === null || v2 === undefined || (_v2$event = v2.event) === null || _v2$event === undefined || (_v2$event = _v2$event.data) === null || _v2$event === undefined ? undefined : _v2$event.filterId) === (item === null || item === undefined || (_item$event = item.event) === null || _item$event === undefined || (_item$event = _item$event.data) === null || _item$event === undefined ? undefined : _item$event.filterId);
        }) === i;
      }) : data;
      try {
        Storage.storage.setItem(storageKey, Storage.handleData(realData));
      } catch (e) {
        if (typeof onError === 'function') onError(e);
      }
    });
    _defineProperty(this, "getSync", function (name, key) {
      var onError = arguments.length > 3 ? arguments[3] : undefined;
      try {
        var storageKey = Storage.generateKey(name, key);
        var returnValue = Storage.storage.getItem(storageKey);
        if (!returnValue) {
          // const message = Storage.notFoundMessage.replace('__key__', storageKey);
          // Logger.info(message, withConsole, Storage.printMessageStyle);
          return;
        }
        return JSON.parse(returnValue);
      } catch (e) {
        if (typeof onError === 'function') onError(e);
      }
    });
    _defineProperty(this, "removeSync", function (name, key, onError) {
      try {
        var storageKey = Storage.generateKey(name, key);
        Storage.storage.removeItem(storageKey);
      } catch (e) {
        if (typeof onError === 'function') onError(e);
      }
    });
    _defineProperty(this, "clearSync", function (onError) {
      try {
        Storage.storage.clear();
      } catch (e) {
        if (typeof onError === 'function') onError(e);
      }
    });
    _defineProperty(this, "removeItem", function (name, key, onError) {
      try {
        Storage.storage.removeItem(key);
      } catch (e) {
        if (typeof onError === 'function') onError(e);
      }
    });
  }
  return _createClass(Storage, null, [{
    key: "handleData",
    value: function handleData(data) {
      return JSON.stringify(data, Storage.replacer);
    }
  }]);
}();
_Storage = Storage;
_defineProperty(Storage, "existMessage", 'there already exists data in storage with this key: %c__key__');
_defineProperty(Storage, "notFoundMessage", 'there is not found any existing data in storage with this key: %c__key__');
_defineProperty(Storage, "printMessageStyle", 'font-weight: bold; font-size: 12px');
_defineProperty(Storage, "notAllowedTypes", ['function', 'symbol', 'bigint']);
_defineProperty(Storage, "storage", IS_BROWSER && isLocalStorageAvailable() || fakeStorage);
_defineProperty(Storage, "generateKey", function (name, key) {
  return "".concat(name).concat(key);
});
_defineProperty(Storage, "replacer", function (key, value) {
  var typeOfValue = _typeof(value);
  if (_Storage.notAllowedTypes.includes(typeOfValue)) ;
  return value;
});
var storageApi = new Storage();

export { storageApi as default };
//# sourceMappingURL=index.js.map
